import React, { useEffect, useRef, useState } from 'react';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import Nav from '../../components/Nav';
import Header from '../../components/Header';
import SearchClient from '../../components/SearchClient';
import OrderItem from '../../components/OrderItem';
import { setLoading } from '../../redux/actions/loader.action';
import axios from 'axios';
import { logout } from '../../redux/actions/auth.action';
import { dateFormat, endpoint, endpointApi } from '../../utils';
import { changeElementInList, getProformaInvoices } from '../../redux/actions/proforma_invoice.action';
import Paginate from '../../components/Paginate';

export default function ProformaInvoicesPage() {
    const jwt_access = localStorage.getItem('jwt_access');
    const location = useLocation();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const proformaInvoices = useSelector(state => state.proformaInvoices);
    const { me } = useSelector(state => state.auth);

    const addModalRef = useRef(null);
    const updateModalRef = useRef(null);
    const detailsModalRef = useRef(null);
    const addFormRef = useRef(null);
    const updateFormRef = useRef(null);
    
    const [modal, setModal] = useState(null);
    const [actionModal, setActionModal] = useState(null);
    const [client, setClient] = useState(null);
    const [proformaInvoice, setProformaInvoice] = useState(null);
    
    const [code, setCode] = useState("");
    const [date, setDate] = useState("");
    const [withdrawalFeesViaMvola, setWithdrawalFeesViaMvola] = useState("");
    const [delivryFees, setDelivryFees] = useState("");
    const [shippingFees, setShippingFees] = useState("");
    const [discount, setDiscount] = useState(0.00);
    const [status, setStatus] = useState("");
    const [isDiscountTouched, setIsDiscountTouched] = useState(false);
    const [isCodeTouched, setIsCodeTouched] = useState(false);
    const [isDateTouched, setIsDateTouched] = useState(false);
    const [isStatusTouched, setIsStatusTouched] = useState(false);

    const [key, setKey] = useState(1);
    const [items, setItems] = useState([{key: 0}]);
    const [errors, setErrors] = useState(null);

    const addItem = () => {
        setItems([...items, {key: key + 1}]);
        setKey(key + 1);
    }
    
    const removeItem = (key) => {
        if(items.length > 1 || modal === "update")
            setItems(items.filter(item => item.key !== key));
    }

    useEffect(() => {
        dispatch(getProformaInvoices(location, navigate));
    }, [location, dispatch, navigate]);

    useEffect(() => {
        if(modal !== 'update'){
            if(addFormRef.current)
                addFormRef.current.reset();
            
            if(updateFormRef.current && modal === null)
                updateFormRef.current.reset();
            
            setClient(null);
            setItems([{key: 1}]);
            setDate("");
            setCode("");
            setWithdrawalFeesViaMvola("");
            setDelivryFees("");
            setShippingFees("");
            setDiscount(0.00);
            setStatus("");
            setIsCodeTouched(false);
            setIsDiscountTouched(false);
            setIsDateTouched(false);
            setIsStatusTouched(false);

            setErrors(null);
        }
    }, [modal]);

    useEffect(() => {
        if(proformaInvoice && modal === 'update'){
            if(addFormRef.current)
                addFormRef.current.reset();

            setCode(proformaInvoice.code);
            setDate(proformaInvoice.date);
            setWithdrawalFeesViaMvola(proformaInvoice.withdrawal_fees_via_mvola ? proformaInvoice.withdrawal_fees_via_mvola : '');
            setDelivryFees(proformaInvoice.delivry_fees ? proformaInvoice.delivry_fees : '');
            setShippingFees(proformaInvoice.shipping_fees ? proformaInvoice.shipping_fees : '');
            setDiscount(proformaInvoice.discount ? proformaInvoice.discount : 0.00);
            setStatus(proformaInvoice.status);
            setClient(proformaInvoice.client);
            setItems([]);
        }
    }, [modal, proformaInvoice]);

    useEffect(() => {
        const clickModalOutside = (e) => {
            if(addModalRef.current === e.target || updateModalRef.current === e.target || detailsModalRef.current === e.target || e.target.classList.contains('_modal-close'))
            {
                setModal(null);
            }
        }
        document.addEventListener('click', clickModalOutside);
        return () => {
            document.removeEventListener('click', clickModalOutside);
        }
    }, []);

    useEffect(() => {
        const clickOutsideActionModal = (e) => {
            const $actionModals = document.querySelectorAll('.actions>ul');
            $actionModals.forEach($actionModal => {
                if($actionModal && !$actionModal.contains(e.target) && $actionModal.classList.contains('active')){
                    setActionModal(null);
                }
            });
        }
        document.addEventListener('click', clickOutsideActionModal);
        return () => {
            document.removeEventListener('click', clickOutsideActionModal);
        }
    }, []);

    const handleSubmitAdd = async(e) => {
        e.preventDefault();
        setErrors(null);
        dispatch(setLoading(true));

        const data = new FormData(e.target);
        await axios.post(`${ endpointApi }proforma-invoices`, data, {
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': `Bearer ${ jwt_access }`
                        }            
                    })
                    .then(({ data }) => {
                        dispatch(getProformaInvoices(location, navigate));
                        setProformaInvoice(data);
                        setModal("details");
                    })
                    .catch(err => {
                        if(err.response.status === 401){
                            dispatch(logout(location.pathname + location.search, navigate));
                        }else{
                            setErrors(err.response && err.response.data && err.response.data.errors ? err.response.data.errors : {error: err.response.data && err.response.data.message ? err.response.data.message : err.message});
                            const $modals = document.querySelectorAll('._modal-content');
                            $modals.forEach($modal => {
                                $modal.scrollTop = 0;
                            });
                        }
                    })
                    .finally(() => {
                        dispatch(setLoading(false));
                    });
    }

    const handleSubmitUpdate = async(e) => {
        e.preventDefault();
        setErrors(null);
        dispatch(setLoading(true));

        const data = new FormData(e.target);
        await axios.put(`${ endpointApi }proforma-invoices/${ proformaInvoice?.id }`, data, {
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': `Bearer ${ jwt_access }`
                        }            
                    })
                    .then(({ data }) => {
                        dispatch(getProformaInvoices(location, navigate));
                        setProformaInvoice(data);
                        setModal("details");
                    })
                    .catch(err => {
                        if(err.response.status === 401){
                            dispatch(logout(location.pathname + location.search, navigate));
                        }else{
                            setErrors(err.response && err.response.data && err.response.data.errors ? err.response.data.errors : {error: err.response.data && err.response.data.message ? err.response.data.message : err.message});
                            const $modals = document.querySelectorAll('._modal-content');
                            $modals.forEach($modal => {
                                $modal.scrollTop = 0;
                            });
                        }
                    })
                    .finally(() => {
                        dispatch(setLoading(false));
                    });
    }

    const deteteProformaInvoiceItem = async(id) => {
        dispatch(setLoading(true));
        try {
            const { data } = await axios.delete(`${ endpointApi }proforma-invoices/${ proformaInvoice?.id }/remove-item/${ id }`, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${ jwt_access }`
                }  
            });
            
            setProformaInvoice(data);
            dispatch(changeElementInList(data));
        } catch (err) {
            if(err.response.status === 401){
                dispatch(logout(location.pathname + location.search, navigate));
            }
        }
        dispatch(setLoading(false));
    }

    const f_eval = (val) => {
        return eval(val);
    }

    useEffect(() => {
        if(!jwt_access){
            navigate('/login?redirect_to=' + location.pathname + location.search);
        }
    }, [location, navigate, jwt_access]);

    return (
        me &&
        <HelmetProvider>
            <Helmet>
                <title>Factures proformas - Société Mikalo</title>
            </Helmet>

            <Header />

            <Nav />

            <main id='main'>
                <div className='title d-flex justify-content-between'>
                    <h1>Factures proformas</h1>
                    <button type='button' onClick={ () => {
                        setModal('add');
                    } } className='btn btn-primary'><i className='fa fa-plus'></i> Créer</button>
                </div>

                <div ref={ addModalRef } className={ `_modal${ modal === 'add' ? ' active' : '' }` }>
                    <div className='_modal-content'>
                        <div className='_modal-head'>
                            <h4>Créer une facture proforma</h4>
                            <button type="button" className='_modal-close'>&times;</button>
                        </div>
                        <div className='_modal-body'>
                            <form ref={ addFormRef } className='form' onSubmit={ handleSubmitAdd }>
                                { errors && errors.error && <div className='alert alert-danger'>{ errors.error }</div> }
                                <div className='mb-3'>
                                    <label htmlFor='date' className='required'>Date de la facture</label>
                                    <input type="date" id='date' name='date' value={ date } onChange={ (e) => setDate(e.target.value) } onBlur={ () => setIsDateTouched(true) } required className='form-control' />
                                    { isDateTouched && date.length === 0 && <div className='form-error'>Veuillez sélectionner la date de la facture.</div> }
                                </div>

                                <div className='mb-3'>
                                    <label htmlFor='client_id' className='required'>Client</label>
                                    <input type='hidden' name='client_id' className='form-control' value={ client ? client.id : "" } />
                                    <SearchClient updateClient={ setClient } reset={ modal !== "add" } required={ true } defaultValue={ client } />
                                </div>

                                { items.map((item, index) => {
                                    return(
                                        <OrderItem item={ index } itemKey={ item.key } key={ item.key } onRemove={ removeItem } errors={ errors } reset={ modal !== "add" } />
                                    )
                                }) }
                                <div className='mb-3 text-end'>
                                    <button type='button' onClick={ addItem } className='btn btn-sm btn-info'><i className='fa fa-plus'></i> Ajouter un produit</button>
                                </div>

                                <div className='mb-3'>
                                    <label htmlFor='withdrawal_fees_via_mvola'>Frais de retrait via mvola</label>
                                    <input type='number' min={ 0 } step={ 0.01 } id='withdrawal_fees_via_mvola' name='withdrawal_fees_via_mvola' placeholder='Frais de retrait via mvola' className='form-control' value={ withdrawalFeesViaMvola } onChange={ (e) => setWithdrawalFeesViaMvola(e.target.value) } />
                                    { errors && errors.withdrawal_fees_via_mvola && <div className='form-error'>{ errors.withdrawal_fees_via_mvola[0] }</div> }
                                </div>
                                
                                <div className='mb-3'>
                                    <label htmlFor='delivry_fees'>Frais de livraison</label>
                                    <input type='number' min={ 0 } step={ 0.01 } id='delivry_fees' name='delivry_fees' placeholder='Frais de livraison' className='form-control' value={ delivryFees } onChange={ (e) => setDelivryFees(e.target.value) } />
                                    { errors && errors.delivry_fees && <div className='form-error'>{ errors.delivry_fees[0] }</div> }
                                </div>

                                <div className='mb-3'>
                                    <label htmlFor='shipping_fees'>Frais d'envoi</label>
                                    <input type='number' min={ 0 } step={ 0.01 } id='shipping_fees' name='shipping_fees' placeholder="Frais d'envoi" className='form-control' value={ shippingFees } onChange={ (e) => setShippingFees(e.target.value) } />
                                    { errors && errors.shipping_fees && <div className='form-error'>{ errors.shipping_fees[0] }</div> }
                                </div>

                                <div className='mb-3'>
                                    <label htmlFor='discount'>Remise (en %)</label>
                                    <input type='number' min={ 0 } step={ 0.01 } id='discount' name='discount' placeholder="Remise (en %)" className='form-control' value={ discount } onChange={ (e) => setDiscount(e.target.value) } onBlur={ () => setIsDiscountTouched(true) } />
                                    { isDiscountTouched && discount.length === 0 && <div className='form-error'>Ce champ ne peut pas être vide.</div> }
                                    { errors && errors.discount && <div className='form-error'>{ errors.discount[0] }</div> }
                                </div>

                                <div className='mb-3'>
                                    <label htmlFor='status' className='required'>Etat</label>
                                    <select id='status' name='status' className='form-control' value={ status } onChange={ (e) => setStatus(e.target.value) } onBlur={ () => setIsStatusTouched(true) } required>
                                        <option value="">Sélectionner</option>
                                        <option value="Draft">Brouillon</option>
                                        <option value="Sent">Envoyée</option>
                                        <option value="Accepted">Acceptée</option>
                                        <option value="Rejected">Rejetée</option>
                                        <option value="Cencelled">Annulée</option>
                                    </select>
                                    { isStatusTouched && status.length === 0 && <div className='form-error'>Veuillez sélectionner l'état de la facture.</div> }
                                </div>

                                <div className='pt-2 text-end'>
                                    <button type='submit' className='btn btn-lg btn-primary' disabled={
                                        date.length === 0 || status.length === 0 || client === null
                                    }><i className='fa fa-save'></i> Enregistrer</button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>

                <div ref={ updateModalRef } className={ `_modal${ modal === 'update' && proformaInvoice ? ' active' : '' }` }>
                    <div className='_modal-content'>
                        <div className='_modal-head'>
                            { proformaInvoice && 
                            <h4>Modifier la facture proforma N° { proformaInvoice.code }</h4> }
                            <button type="button" className='_modal-close'>&times;</button>
                        </div>
                        <div className='_modal-body'>
                            <form ref={ updateFormRef } className='form' onSubmit={ handleSubmitUpdate }>
                                { errors && errors.error && <div className='alert alert-danger'>{ errors.error }</div> }
                                <div className='mb-3'>
                                    <label htmlFor='code' className='required'>Code</label>
                                    <input type="text" id='code' name='code' value={ code } placeholder='Code' autoComplete='off' onChange={ (e) => setCode(e.target.value) } onBlur={ () => setIsCodeTouched(true) } required className='form-control' />
                                    { isCodeTouched && code.length === 0 && <div className='form-error'>Veuillez saisir le code facture proforma.</div> }
                                    { isCodeTouched && code.length > 0 && /^FAC\/\d{4}\/\d{4,}$/.test(code) === false && <div className='form-error'>Le code facture proforma n'est pas valide. Le format valide est: FAC/[année]/[numéro d'ordre].</div> }
                                </div>
                                
                                <div className='mb-3'>
                                    <label htmlFor='_date' className='required'>Date de la facture</label>
                                    <input type="date" id='_date' name='date' value={ date } onChange={ (e) => setDate(e.target.value) } onBlur={ () => setIsDateTouched(true) } required className='form-control' />
                                    { isDateTouched && date.length === 0 && <div className='form-error'>Veuillez sélectionner la date de la facture.</div> }
                                </div>

                                <div className='mb-3'>
                                    <label htmlFor='_client_id' className='required'>Client</label>
                                    <input type='hidden' name='client_id' className='form-control' value={ client ? client.id : "" } />
                                    <SearchClient updateClient={ setClient } reset={ modal !== "update" } id='_client_id' required={ true } defaultValue={ client } />
                                </div>

                                <div className='mb-3'>
                                    <div className='_label'>Produits</div>
                                    <div className='_value'>
                                        <table className='table table-striped'>
                                            <thead>
                                                <tr>
                                                    <th width="50"></th>
                                                    <th>Nom du produit</th>
                                                    <th>Quantité</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                            { proformaInvoice && proformaInvoice.items.map((item, index) => {
                                                return(
                                                <tr key={ index }>
                                                    <td>
                                                        <button type='button' className='delete_product_button' onClick={ () => {
                                                            deteteProformaInvoiceItem(item.id);
                                                        }}><i className='fa fa-trash'></i></button>
                                                    </td>
                                                    <td>{ item.product.code } - { item.product.name } - { item.product.subtitle }</td>
                                                    <td>{ item.quantity }{ item.product.unit ? ' ' + (item.product.unit === 'Item' ? 'pièce' : (item.product.unit === 'Box' ? 'boîte' : 'carton')) + (item.quantity > 1 ? 's' : '') : '' }</td>
                                                </tr>
                                                )
                                            }) }
                                            </tbody>
                                        </table>
                                    </div>
                                </div>

                                { items.map((item, index) => {
                                    return(
                                        <OrderItem item={ index } id='_product_id' itemKey={ item.key } key={ item.key } onRemove={ removeItem } errors={ errors } reset={ modal !== "update" } />
                                    )
                                }) }
                                <div className='mb-3 text-end'>
                                    <button type='button' onClick={ addItem } className='btn btn-sm btn-info'><i className='fa fa-plus'></i> Ajouter un produit</button>
                                </div>

                                <div className='mb-3'>
                                    <label htmlFor='_withdrawal_fees_via_mvola'>Frais de retrait via mvola</label>
                                    <input type='number' min={ 0 } step={ 0.01 } id='_withdrawal_fees_via_mvola' name='withdrawal_fees_via_mvola' placeholder='Frais de retrait via mvola' className='form-control' value={ withdrawalFeesViaMvola } onChange={ (e) => setWithdrawalFeesViaMvola(e.target.value) } />
                                    { errors && errors.withdrawal_fees_via_mvola && <div className='form-error'>{ errors.withdrawal_fees_via_mvola[0] }</div> }
                                </div>
                                
                                <div className='mb-3'>
                                    <label htmlFor='_delivry_fees'>Frais de livraison</label>
                                    <input type='number' min={ 0 } step={ 0.01 } id='_delivry_fees' name='delivry_fees' placeholder='Frais de livraison' className='form-control' value={ delivryFees } onChange={ (e) => setDelivryFees(e.target.value) } />
                                    { errors && errors.delivry_fees && <div className='form-error'>{ errors.delivry_fees[0] }</div> }
                                </div>

                                <div className='mb-3'>
                                    <label htmlFor='_shipping_fees'>Frais d'envoi</label>
                                    <input type='number' min={ 0 } step={ 0.01 } id='_shipping_fees' name='shipping_fees' placeholder="Frais d'envoi" className='form-control' value={ shippingFees } onChange={ (e) => setShippingFees(e.target.value) } />
                                    { errors && errors.shipping_fees && <div className='form-error'>{ errors.shipping_fees[0] }</div> }
                                </div>

                                <div className='mb-3'>
                                    <label htmlFor='_discount'>Remise (en %)</label>
                                    <input type='number' min={ 0 } step={ 0.01 } id='_discount' name='discount' placeholder="Remise (en %)" className='form-control' value={ discount } onChange={ (e) => setDiscount(e.target.value) } onBlur={ () => setIsDiscountTouched(true) } />
                                    { isDiscountTouched && discount.length === 0 && <div className='form-error'>Ce champ ne peut pas être vide.</div> }
                                    { errors && errors.discount && <div className='form-error'>{ errors.discount[0] }</div> }
                                </div>

                                <div className='mb-3'>
                                    <label htmlFor='_status' className='required'>Etat</label>
                                    <select id='_status' name='status' className='form-control' value={ status } onChange={ (e) => setStatus(e.target.value) } onBlur={ () => setIsStatusTouched(true) } required>
                                        <option value="">Sélectionner</option>
                                        <option value="Draft">Brouillon</option>
                                        <option value="Sent">Envoyée</option>
                                        <option value="Accepted">Acceptée</option>
                                        <option value="Rejected">Rejetée</option>
                                        <option value="Cencelled">Annulée</option>
                                    </select>
                                    { isStatusTouched && status.length === 0 && <div className='form-error'>Veuillez sélectionner l'état de la facture.</div> }
                                </div>

                                <div className='pt-2 text-end'>
                                    <button type='submit' className='btn btn-lg btn-primary' disabled={
                                        date.length === 0 || status.length === 0 || client === null ||
                                        (proformaInvoice && code === proformaInvoice.code && date === proformaInvoice.date && status === proformaInvoice.status && client === proformaInvoice.client && items.length === 0)
                                    }><i className='fa fa-save'></i> Mettre à jour</button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>

                <div ref={ detailsModalRef } className={ `_modal${ modal === 'details' && proformaInvoice ? ' active' : '' }` }>
                    <div className='_modal-content'>
                        <div className='_modal-head'>
                            { proformaInvoice && 
                            <h4>Facture proforma N° { proformaInvoice.code }</h4> }
                            <button type="button" className='_modal-close'>&times;</button>
                        </div>
                        <div className='_modal-body'>
                        { proformaInvoice && <>
                            <div className='row'>
                                <div className='col-6 mb-3'>
                                    <div className='_label'>Code</div>
                                    <div className='_value'>{ proformaInvoice.code }</div>
                                </div>
                                <div className='col-6 mb-3'>
                                    <div className='_label'>Date</div>
                                    <div className='_value'>{ dateFormat(proformaInvoice.date) }</div>
                                </div>
                            </div>

                            <div className='mb-3'>
                                <div className='_label'>Client</div>
                                <div className='_value'>
                                    { proformaInvoice.client ? (proformaInvoice.client.type === "Company" ? proformaInvoice.client.company_name : proformaInvoice.client.last_name + " " + proformaInvoice.client.first_name) : '-' }
                                    <br/>
                                    { proformaInvoice.client ? proformaInvoice.client.address + ", " + proformaInvoice.client.zipcode + " " + proformaInvoice.client.city + ", " + proformaInvoice.client.country : "-" }
                                    <br/>
                                    { proformaInvoice.client ? (proformaInvoice.client.email ? "E-mail: " : "") + proformaInvoice.client.email + (proformaInvoice.client.phone ? (proformaInvoice.client.email ? " - Tél: " : "Tél: ") + proformaInvoice.client.phone : "") + (proformaInvoice.client.website ? (proformaInvoice.client.email || proformaInvoice.client.phone ? " - Site web: " : "Site web: ") + proformaInvoice.client.website : "") : "-" }
                                </div>
                            </div>

                            <div className='row'>
                                <div className='col-6 mb-3'>
                                    <div className='_label'>Montant</div>
                                    <div className='_value'>{ new Intl.NumberFormat('fr-FR', {maximumFractionDigits: 2, minimumFractionDigits: 2}).format(f_eval(proformaInvoice.total_amount + '+' + proformaInvoice.withdrawal_fees_via_mvola + '+' + proformaInvoice.delivry_fees + '+' + proformaInvoice.shipping_fees)) } Ariary</div>
                                </div>

                                <div className='col-6 mb-3'>
                                    <div className='_label'>Etat</div>
                                    <div className='_value'>{ proformaInvoice.status === "Sent" ? <span className="badge bg-info">Envoyée</span> : (proformaInvoice.status === "Accepted" ? <span className="badge bg-success">Acceptée</span> : (proformaInvoice.status === "Rejected" ? <span className="badge bg-danger">Rejetée</span> : (proformaInvoice.status === "Cancelled" ? <span className="badge bg-dark">Annulée</span> : <span className="badge bg-dark">Brouillon</span>)))}</div>
                                </div>

                                <div className='mb-3'>
                                    <div className='_label'>Produits</div>
                                    <div className='_value'>
                                        <table className='table table-striped'>
                                            <thead>
                                            <tr>
                                                <th>Nom du produit</th>
                                                <th>Quantité</th>
                                                <th>Prix unit. (Ariary)</th>
                                                <th>Montant HT (Ariary)</th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                                { proformaInvoice.items.map((item, index) => {
                                                return(
                                                <tr key={ index }>
                                                    <td>{ item.product.code } - { item.product.name } - { item.product.subtitle }</td>
                                                    <td>{ item.quantity }{ item.product.unit ? ' ' + (item.product.unit === 'Item' ? 'pièce' : (item.product.unit === 'Box' ? 'boîte' : 'carton')) + (item.quantity > 1 ? 's' : '') : '' }</td>
                                                    <td>{ new Intl.NumberFormat('fr-FR', {maximumFractionDigits: 2, minimumFractionDigits: 2}).format(item.unit_price) }</td>
                                                    <td>{ new Intl.NumberFormat('fr-FR', {maximumFractionDigits: 2, minimumFractionDigits: 2}).format(item.unit_price * item.quantity) }</td>
                                                </tr>
                                                )
                                                }) }

                                                { proformaInvoice.withdrawal_fees_via_mvola &&
                                                <tr>
                                                    <td colSpan={ 3 }>Frais de retrait via mvola</td>
                                                    <td>{ new Intl.NumberFormat('fr-FR', {maximumFractionDigits: 2, minimumFractionDigits: 2}).format(proformaInvoice.withdrawal_fees_via_mvola) }</td>
                                                </tr> }
                                                { proformaInvoice.delivry_fees &&
                                                <tr>
                                                    <td colSpan={ 3 }>Frais de livraison</td>
                                                    <td>{ new Intl.NumberFormat('fr-FR', {maximumFractionDigits: 2, minimumFractionDigits: 2}).format(proformaInvoice.delivry_fees) }</td>
                                                </tr> }
                                                { proformaInvoice.shipping_fees &&
                                                <tr>
                                                    <td colSpan={ 3 }>Frais d'envoi</td>
                                                    <td>{ new Intl.NumberFormat('fr-FR', {maximumFractionDigits: 2, minimumFractionDigits: 2}).format(proformaInvoice.shipping_fees) }</td>
                                                </tr> }
                                                <tr>
                                                    <th colSpan={ 3 }>Sous-total</th>
                                                    <th>{ new Intl.NumberFormat('fr-FR', {maximumFractionDigits: 2, minimumFractionDigits: 2}).format(f_eval('(' + proformaInvoice.total_amount + '/(' + 1 + '-' + proformaInvoice.discount + '/' + 100 + ')' + ')' + '+' + proformaInvoice.withdrawal_fees_via_mvola + '+' + proformaInvoice.delivry_fees + '+' + proformaInvoice.shipping_fees)) }</th>
                                                </tr>
                                                { proformaInvoice.discount && proformaInvoice.discount > 0 &&
                                                <tr>
                                                    <th colSpan={ 3 }>Remise ({ new Intl.NumberFormat('fr-FR', {maximumFractionDigits: 2, minimumFractionDigits: 2}).format(proformaInvoice.discount) }%)</th>
                                                    <th>{ new Intl.NumberFormat('fr-FR', {maximumFractionDigits: 2, minimumFractionDigits: 2}).format(f_eval(proformaInvoice.discount + '/100*(' + proformaInvoice.total_amount + '/(' + 1 + '-' + proformaInvoice.discount + '/' + 100 + ')' + ')')) }</th>
                                                </tr> }
                                                <tr>
                                                    <th colSpan={ 3 } className='text-uppercase'>Total</th>
                                                    <th>{ new Intl.NumberFormat('fr-FR', {maximumFractionDigits: 2, minimumFractionDigits: 2}).format(f_eval(proformaInvoice.total_amount + '+' + proformaInvoice.withdrawal_fees_via_mvola + '+' + proformaInvoice.delivry_fees + '+' + proformaInvoice.shipping_fees)) }</th>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>

                                <div className='text-center pt-2'>
                                    <a href={ `${ endpoint }proforma-invoice/${ proformaInvoice.id }/download` } target='_blank' rel="noreferrer" className='btn btn-lg btn-orange me-3' onClick={ () => setModal("edit") }><i className='fa fa-download'></i> Télécharger</a>
                                    <button type='button' className='btn btn-lg btn-primary' onClick={ () => setModal("update") }><i className='fa fa-edit'></i> Modifier</button>
                                </div>
                            </div>
                        </> }
                        </div>
                    </div>
                </div>

                <div className='box'>
                    <table className='table table-striped'>
                        <thead>
                            <tr>
                                <th width="100">Code</th>
                                <th width="100">Date</th>
                                <th>Client</th>
                                <th>Montant</th>
                                <th width="120">Statut</th>
                                <th width="75" className="text-end">Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            { proformaInvoices.loading && <tr><td colSpan={ 6 }>Chargement...</td></tr> }
                            { proformaInvoices.loading === false && proformaInvoices.data && proformaInvoices.data.total === 0 && <tr><td colSpan={ 6 }>Aucun élément trouvé</td></tr> }
                            { proformaInvoices.loading === false && proformaInvoices.data && proformaInvoices.data.data && proformaInvoices.data.data.map((item, index) => {
                            return (
                            <tr key={ index }>
                                <td>{ item.code }</td>
                                <td>{ dateFormat(item.date) }</td>
                                <td>{ item.client ? (item.client.type === 'Company' ? item.client.company_name : item.client.last_name + " " + item.client.first_name) : 'Non renseigné' }</td>
                                <td>{ new Intl.NumberFormat('fr-FR', {maximumFractionDigits: 2, minimumFractionDigits: 2}).format(item.total_amount) } Ariary</td>
                                <td>
                                    { item.status === "Sent" ? <span className="badge bg-info">Envoyée</span> : (item.status === "Accepted" ? <span className="badge bg-success">Acceptée</span> : (item.status === "Rejected" ? <span className="badge bg-danger">Rejetée</span> : (item.status === "Cancelled" ? <span className="badge bg-dark">Annulée</span> : <span className="badge bg-dark">Brouillon</span>)))}
                                </td>
                                <td className="text-end">
                                    <div className='actions'>
                                        <button type='button' className='toggle-action' onClick={ (e) => {
                                        e.stopPropagation();
                                        setActionModal(actionModal !== item.id ? item.id : null);
                                        } }><i className='fa fa-ellipsis-v'></i></button>
                                        <ul className={ actionModal === item.id ? 'active' : '' }>
                                            <li><button type='button' onClick={ () => {
                                                setActionModal(null);
                                                setModal("details");
                                                setProformaInvoice(item);
                                            } }><i className="fa fa-eye"></i> Voir les détails</button></li>
                                            <li><a href={ `${ endpoint }proforma-invoice/${ item.id }/download` } target='_blank' rel="noreferrer" onClick={ () => {
                                                setActionModal(null);
                                            } }><i className="fa fa-download"></i> Télécharger</a></li>
                                            <li><button type='button' onClick={ () => {
                                                setActionModal(null);
                                                setModal("update");
                                                setProformaInvoice(item);
                                            } }><i className="fa fa-edit"></i> Modifier</button></li>
                                        </ul>
                                    </div>
                                </td>
                            </tr> ) })}
                        </tbody>
                    </table>
                </div>
                    
                { proformaInvoices && proformaInvoices.data &&
                <Paginate currentPage={ proformaInvoices.data.current_page } totalPages={ proformaInvoices.data.last_page } pathname={ location.pathname } search={ location.search } /> }
            </main>
        </HelmetProvider>
    )
}
